export const userGuideNames = {
  ignite: 'Ignite.pdf',
  lenderHub: 'LenderHub.pdf',
};
